import React, { useEffect, useState } from "react";
import InputFieldsEmailTextPassword from "../common/InputFieldsEmailTextPassword";
import LinkCommonComponent from "../common/LinkCommonComponent";
import Checkbox from "rc-checkbox";
import "rc-checkbox/assets/index.css";

export default function WelcomeLogin() {
  const [values, setValues] = useState({
    email: "",
    password: "",
    loggedIn: true,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /*===========================================
                handleOnChange
===========================================*/
  const handleOnChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
    // console.log(values);
  };

  const handleOnCheckbox = (e) => {
    setValues({
      ...values,
      loggedIn: e.target.checked,
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log(values);
  // };
  /*===========================================
                renderLeftBlock
===========================================*/
  const renderLeftBlock = () => {
    return (
      <div className="welcome-select-left-section welcome-select-left-section--login">
        <h4 className="font-36-nunito-semibold">
          Expand your business and reach.{" "}
        </h4>
        <p className="font-18-nunito-light pt-25">
          Lorem ipsum dolor sit amet, consectetur adipiscing
          <br /> elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua.{" "}
        </p>
      </div>
    );
  };

  /*===========================================
                return
===========================================*/
  return (
    <div className="mt-auth-platform-bg">
      <div className="custom-d-flex flex-nowrap align-items-center">
        {renderLeftBlock()}
        <div className="welcome-login-right-section">
          <h2 className="font-48-nunito-semibold purple-green-gradient-text">
            Welcome to Myrl Tech
          </h2>
          <p className="font-24-nunito-semibold welcome-select-choose-company-text">
            Please enter your login details to start
          </p>
          {/* <form noValidate onSubmit={handleSubmit}> */}
          <InputFieldsEmailTextPassword
            type="email"
            name="email"
            value={values.email}
            placeholder="mail@mail.com"
            onChange={handleOnChange}
            label="Email Address"
          />
          <InputFieldsEmailTextPassword
            containerClassName="pt-35"
            type="password"
            name="password"
            values={values.password}
            placeholder="************"
            onChange={handleOnChange}
            label="Password"
          />
          <div className="customCheckbox">
            <Checkbox
              id="loggedIn"
              value={values.loggedIn}
              checked={values.loggedIn}
              defaultChecked={false}
              onChange={handleOnCheckbox}
            />
            <label htmlFor="loggedIn">Stay Logged in</label>
          </div>{" "}
          {/* </form> */}
          <div className="welcome-login-btn-div">
            <span className="welcome-login-forgot-password-text">
              Forgot Password?
            </span>
            <LinkCommonComponent
              linkPath="/welcome-first-time"
              linkText="Login"
              extraClassName="welcome-select-login-btn welcome-select-login-btn--login"
            />
          </div>{" "}
        </div>{" "}
      </div>
    </div>
  );
}
